module.exports = __webpack_public_path__ + "static/media/ulldeltemps_medium@2x.d5573756.jpg";